import $ from 'jquery';
import config from './../../../config';

export function get_ch_department( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'GET_CH_DEPARTMENT',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_CH_DEPARTMENT",
				checklist: response
			})
		})

	}
}

export function save_checklist( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'SAVE_CHECKLIST',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_CHECKLIST",
				checklist: response
			})
		})

	}
}

export function get_checklist( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'GET_CHECKLIST',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_CHECKLIST",
				checklist: response
			})
		})

	}
}

export function delete_checklist( check_list_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'DELETE_CHECKLIST',
				check_list_id: check_list_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_CHECKLIST",
				checklist: response
			})
		})

	}
}

export function update_checklist_department( department, id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'UPDATE_CH_DEPARTMENT',
				department: department,
				checklist_id:id
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_CH_DEPARTMENT",
				checklist: response
			})
		})

	}
}


export function update_checklist_type( type, id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'UPDATE_CH_TYPE',
				type: type,
				checklist_id:id
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_CH_TYPE",
				checklist: response
			})
		})

	}
}





export function update_checklist( checklist, id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'settings/check-list/',
			data: {
                method: 'UPDATE_CHECKLIST',
				checklist: checklist,
				checklist_id:id
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_CHECKLIST",
				checklist: response
			})
		})

	}
}






// WEBPACK FOOTER //
// ./src/pages/check_list/actions/checklist.action.js